<template>
  <v-app>
    <v-main>
      <v-container fluid>
        <v-card>
          <v-card-text>
            <v-container fluid>
              <v-row no-gutters>
                <v-col cols="12" md="3">
                  <v-text-field
                      @keyup.enter="onEnter"
                      v-model="imePrezime"
                      label="Ime i prezime"
                      prepend-icon="mdi-account">
                      <!--:disabled="imePrezimeDisabled">-->
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                      @keyup.enter="onEnter"
                      v-model="kljucneRijeci"
                      label="Ključne riječi"
                      prepend-icon="mdi-key">
                      <!--:disabled="kljucneRijeciDisabled">-->
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                      @keyup.enter="onEnter"
                      v-model="ustanova"
                      label="Ustanova"
                      prepend-icon="mdi-key">
                      <!--:disabled="ustanovaDisabled">-->
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                      @keyup.enter="onEnter"
                      v-model="nazivProjekta"
                      label="Naziv projekta"
                      prepend-icon="mdi-key">
                      <!--:disabled="nazivProjektaDisabled">-->
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters justify="center">
                <v-col cols="12" md="3">
                  <v-select
                      v-model="vrstaNatjecaja"
                      label="Vrsta natječaja"
                      :items="selectVrstaNatjecajaAxios"
                      prepend-icon="mdi-cog"
                      :loading="vrstaNatjecajaLoading">
                    <!--:disabled="vrstaNatjecajaDisabled"-->
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                      v-model="natjecajniRok"
                      label="Natječajni rok"
                      :items="selectNatjecajiRokAxios"
                      prepend-icon="mdi-calendar"
                      :loading="natjecajniRokLoading">
                    <!--:disabled="natjecajniRokDisabled"-->
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                      v-model="selectedZnanstvenoPoljePodrucje"
                      label="Znanstvena područja/polja"
                      :items="treeZnanstvenoPorducjeSelectItems"
                      prepend-icon="mdi-calendar"
                      :loading="znanstvenoPoljeLoading">
                    <!--:disabled="znanstvenoPoljeDisabled"-->
                  </v-select>
                  <!--<v-menu offset-y>
                      <template v-slot:activator="{ on }">
                          <v-btn
                                  color="primary"
                                  dark
                                  v-on="on"
                          >
                              Dropdown
                          </v-btn>
                      </template>
                      <v-card>
                          <v-treeview
                                  hoverable
                                  activatable
                                  :active="treeZnanstvenoPorducje.active"
                                  :items="treeZnanstvenoPorducje.items"
                                  @update:active="treeZnanstvenoPodrucijeActive"
                          >
                          </v-treeview>
                      </v-card>
                  </v-menu>-->
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                      @keyup.enter="onEnter"
                      v-model="akronim"
                      label="Akronim"
                      prepend-icon="mdi-key">
                      <!--:disabled="akronimDisabled"-->
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" md="4">
                  <v-btn color="#1c2c5f" dark @click="queryHrzzDb" :loading="searchButtonLoader">Traži</v-btn>
                  &nbsp;
                  <v-btn color="#dc3832" dark @click="resetSearch">Ponovi pretragu</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-text v-if="searchResultsDisplay">
            <v-data-table
                :loading="dataTableProjekti.loading"
                :headers="dataTableProjekti.headers"
                :items="dataTableProjekti.projects"
                :single-expand="dataTableProjekti.singleExpand"
                :expanded.sync="dataTableProjekti.expanded"
                item-key="ID"
                show-expand
                class="elevation-1"
                :footer-props="{
                                    showFirstLastPage: true,
                                    itemsPerPageOptions: [5, 10, 15]
                                }"
            >
              <template v-slot:item.actions="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="showPermalink(item.ID)"
                >
                  mdi-link
                </v-icon>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" v-if="vrstaNatjecaja === 'DOK'">
                  <br>
                  <p><strong>Naziv projekta:</strong> {{ item.TitleHr }}</p>
                  <p><strong>Akronim:</strong> {{ item.Acronim }}</p>
                  <p><strong>Mentor:</strong> {{ item.UserFirstLastName }}</p>
                  <p><strong>Sumentor(i):</strong> {{ item.SvouserFirstLastName }}</p>
                  <p><strong></strong> {{ item.TeamMemenersNames }}</p>
                  <p><strong>Trajanje:</strong> {{ item.Duration }}</p>
                  <p><strong>Status:</strong> {{ item.Status }}</p>
                  <p><strong>Znanstveno područje i polje:</strong> {{ item.ScieAreaHr }} /
                    {{ item.ScieFieldHr }}</p>
                  <p><strong>Ustanova:</strong> {{ item.InstitutionHr }}</p>
                </td>
                <td :colspan="headers.length" v-else>
                  <br>
                  <p><strong>Naziv projekta:</strong> {{ item.TitleHr }}</p>
                  <p><strong>Akronim:</strong> {{ item.Acronim }}</p>
                  <p><strong>Voditelj:</strong> {{ item.UserFirstLastName }}</p>
                  <p><strong>Suvoditelj(i):</strong> {{ item.SvouserFirstLastName }}</p>
                  <p><strong>Suradnik/ci:</strong> {{ item.TeamMemenersNames }}</p>
                  <p><strong>Trajanje:</strong> {{ item.Duration }}</p>
                  <p><strong>Status:</strong> {{ item.Status }}</p>
                  <p><strong>Vrijednost:</strong> {{ item.FinancValue }}</p>
                  <p><strong>Znanstveno područje i polje:</strong> {{ item.ScieAreaHr }} /
                    {{ item.ScieFieldHr }}</p>
                  <p><strong>Ustanova:</strong> {{ item.InstitutionHr }}</p>
                  <p><strong>Ključne riječi:</strong> {{ item.KeywordsHr }}</p>
                  <p><strong>Sažetak:</strong> {{ item.SummaryHr }}</p>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
          <!--<v-card-actions>
          </v-card-actions>-->
        </v-card>
        <v-dialog
            v-model="dialog"
            persistent
            max-width="480"
        >
          <v-card>
            <v-card-title class="headline">
              Permalink
            </v-card-title>
            <v-card-text><v-text-field filled readonly v-model=permalink></v-text-field></v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="green darken-1"
                  text
                  @click="permalink = ''; dialog = false"
              >
                OK
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-snackbar
            v-model="snackbar"
            :timeout="timeout"
            absolute
            top
            color="success"
        >
          Poveznica kopirana u međuspremnik.

          <template v-slot:action="{ attrs }">
            <v-btn
                color="white"
                text
                v-bind="attrs"
                @click="snackbar = false"
            >
              OK
            </v-btn>
          </template>
        </v-snackbar>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios';

export default {
  name: 'App',
  data: () => ({
        dialog: false,
        snackbar: false,
        timeout: 3000,
        permalink: '',
        showMenuPodrucjaPolja: false,
        menuPodrucjaPoljaX: 0,
        menuPodrucjaPoljaY: 0,
        searchButtonLoader: false,
        dataTableProjekti: {
          loading: false,
          expanded: [],
          singleExpand: true,
          headers: [
            {
              text: 'Naziv projekta',
              align: 'start',
              sortable: false,
              value: 'TitleHr',
            },
            {text: 'Voditelj', value: 'UserFirstLastName'},
            {text: 'Šifra', value: 'Code'},
            {text: 'Vrsta projekta', value: 'ProposalType'},
            {text: 'Natječajni rok', value: 'ProposalCall'},
            {text: 'Poveznica', value: 'actions', sortable: false},
            {text: 'Detalji', value: 'data-table-expand'},
          ],
          projects: [],
        },
        imePrezime: '',
        imePrezimeDisabled: false,
        kljucneRijeci: '',
        kljucneRijeciDisabled: false,
        akronim: '',
        akronimDisabled: false,
        ustanova: '',
        ustanovaDisabled: false,
        nazivProjekta: '',
        nazivProjektaDisabled: false,
        vrstaNatjecaja: 'Svi',
        vrstaNatjecajaDisabled: false,
        vrstaNatjecajaLoading: true,
        selectVrstaNatjecajaAxios: [],
        selectVrstaNatjecaja: [
          'Svi',
          'DOK',
          'IP',
          'PAR',
          'PKP',
          'PZS',
          'STR',
          'TTP',
          'UIP'
        ],
        natjecajniRok: 'Svi',
        natjecajniRokLoading: true,
        natjecajniRokDisabled: false,
        selectNatjecajiRokAxios: [],
        selectNatjecajniRok: [
          'Svi',
          '2013-11',
          '2014-06',
          '2014-09',
          '2015-02',
          '2015-10',
          '2016-05',
          '2016-06',
          '2017-02',
          '2017-05',
          '2017-09',
          '2018-01',
          '2018-07',
          '2018-09',
          '2019-02',
          '2019-04',
          '2020-01',
          '2020-04'
        ],
        znanstvenoPoljeLoading: true,
        znanstvenoPoljeDisabled: false,
        selectedZnanstvenoPoljePodrucje: {
          text: '',
          value: 0,
        },
        treeZnanstvenoPorducjeSelectItems: [],
        treeZnanstvenoPorducje: {
          polja: [],
          podrucja: [],
          active: [],
          activeElement: {
            id: 0,
            name: ''
          },
          search: '',
          items: [
            {
              id: null,
              name: String,
              children: [],
            }
          ]
        },
        searchResultsDisplay: false,
      }
  ),
  methods: {
    onEnter: function() {
      this.queryHrzzDb();
    },
    getParamValue: function (paramName) {
      let url = window.location.search.substring(1); //get rid of "?" in querystring
      let qArray = url.split('&'); //get key-value pairs
      for (let i = 0; i < qArray.length; i++) {
        let pArr = qArray[i].split('='); //split key and value
        if (pArr[0] === paramName)
          return pArr[1]; //return value
      }
    },
    showPermalink: function (id) {
      this.permalink = "https://hrzz.hr/financiranje/baza-projekata/?ID=" + id + "#baza";
      navigator.clipboard.writeText(this.permalink);
      this.snackbar = true;
      //this.dialog = true;
    },
    resetSearch: function () {
      this.searchResultsDisplay = false;
      this.imePrezimeDisabled = false;
      this.kljucneRijeciDisabled = false;
      this.ustanovaDisabled = false;
      this.vrstaNatjecajaDisabled = false;
      this.natjecajniRokDisabled = false;
      this.znanstvenoPoljeDisabled = false;
      this.akronimDisabled = false;
      this.nazivProjektaDisabled = false;
      this.selectedZnanstvenoPoljePodrucje = {};
      this.dataTableProjekti.projects = [];
    },
    queryHrzzDb: function (ID) {
      let searchID = ID;
      if (typeof searchID === 'object' && searchID !== null) {
        searchID = '';
      }
      this.searchButtonLoader = true;
      this.dataTableProjekti.projects = [];
      this.dataTableProjekti.loading = true;
      let currentFieldArea;
      let postData;
      currentFieldArea = this.treeZnanstvenoPorducjeSelectItems.find(item => item.value === this.selectedZnanstvenoPoljePodrucje)
      if (currentFieldArea !== undefined) {
        postData = {
          ID: searchID,
          imePrezime: this.imePrezime,
          kljucneRijeci: this.kljucneRijeci,
          vrstaNatjecaja: this.vrstaNatjecaja,
          natjecajniRok: this.natjecajniRok,
          ustanova: this.ustanova,
          akronim: this.akronim,
          nazivProjekta: this.nazivProjekta,
          podrucjePolje: currentFieldArea.text
        };
      } else {
        postData = {
          ID: searchID,
          imePrezime: this.imePrezime,
          kljucneRijeci: this.kljucneRijeci,
          vrstaNatjecaja: this.vrstaNatjecaja,
          natjecajniRok: this.natjecajniRok,
          akronim: this.akronim,
          nazivProjekta: this.nazivProjekta,
          ustanova: this.ustanova,
        };
      }
      if (postData.vrstaNatjecaja === 'Svi') {
        postData.vrstaNatjecaja = '';
      }
      if (postData.natjecajniRok === 'Svi') {
        postData.natjecajniRok = '';
      }
      //.post('http://hrzz.hr:8081/queryDb', postData)
      axios
          .post('https://hrzz.hr:8081/queryDbLocal', postData)
          //.post('https://82.214.98.134:8081/queryDbLocal', postData)
          .then(response => {
            this.imePrezimeDisabled = true;
            this.kljucneRijeciDisabled = true;
            this.ustanovaDisabled = true;
            this.vrstaNatjecajaDisabled = true;
            this.natjecajniRokDisabled = true;
            this.znanstvenoPoljeDisabled = true;
            this.akronimDisabled = true;
            this.nazivProjektaDisabled = true;
            if (response.data !== null) {
              this.dataTableProjekti.projects = response.data;
            } else {
              this.dataTableProjekti.projects = [];
            }
            this.searchResultsDisplay = true;
          })
          .catch(error => {
            console.log(error)
            this.dataTableProjekti.projects = [];
          })
          .finally(() => {
            this.dataTableProjekti.loading = false;
            this.searchButtonLoader = false;
          })
    },
    queryHrzzNatjecaji: function () {
      this.natjecajniRokLoading = true;
      this.treeZnanstvenoPorducje.items = [];
      let self = this;
      axios
          //.post('https://82.214.98.134:8081/queryVrste', {})
          .post('https://hrzz.hr:8081/queryVrste', {})
          .then(response => {
            //this.treeZnanstvenoPorducje.items = response.data;
            let rsp = response.data;
            self.selectVrstaNatjecajaAxios = rsp.map(({Naziv}) => Naziv);
            self.selectVrstaNatjecajaAxios.push('Svi');
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            this.natjecajniRokLoading = false;
          })
    },
     queryHrzzRokovi: function () {
      this.vrstaNatjecajaLoading = true;
      this.treeZnanstvenoPorducje.items = [];
      let self = this;
      axios
          .post('https://hrzz.hr:8081/queryRokovi', {})
          //.post('https://82.214.98.134:8081/queryRokovi', {})
          .then(response => {
            //this.treeZnanstvenoPorducje.items = response.data;
            let rsp = response.data;
            self.selectNatjecajiRokAxios = rsp.map(({ID}) => ID);
            self.selectNatjecajiRokAxios.sort(function (a, b) {
              if (a > b) {
                return -1;
              }
              if (b > a) {
                return 1;
              }
              return 0;
            });
            self.selectNatjecajiRokAxios.push('Svi');
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {
            this.vrstaNatjecajaLoading = false;
          })
    },
    queryHrzzPoljaPodrucja: function () {
      this.znanstvenoPoljeLoading = true;
      this.treeZnanstvenoPorducje.items = [];
      axios
          .post('https://hrzz.hr:8081/queryZnanstvenaSkupa', {})
          //.post('https://82.214.98.134:8081/queryZnanstvenaSkupa', {})
          .then(response => {
            //this.treeZnanstvenoPorducje.items = response.data;
            this.treeZnanstvenoPorducjeSelectItems = response.data;
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            this.znanstvenoPoljeLoading = false;
          })
    },
    treeZnanstvenoPodrucijeActive: function (val) {
      console.log(val);
      console.log(this.treeZnanstvenoPorducje.active);
    }
  },
  mounted() {
    this.queryHrzzPoljaPodrucja();
    this.queryHrzzNatjecaji();
    this.queryHrzzRokovi();
    let ID = this.getParamValue('ID');
    if (ID !== undefined && ID !== null && ID !== '') {
      this.queryHrzzDb(ID);
    }
  }
};
</script>
